import React from 'react'
import Radio from '@/components/Radio'
import type { SDUIComponentProps } from '@/types/sduiTypes'

interface RadioOption {
    label: string
    value: string | number
}

/**
 * SDUI Radio adapter — wraps the existing Radio.Group + Radio component
 * to conform to the SDUI component contract.
 */
const SDUIRadio: React.FC<SDUIComponentProps> = ({
    id,
    label,
    value,
    errors,
    disabled,
    options,
    vertical,
    onChange,
}) => {
    const hasErrors = errors && errors.length > 0
    const radioOptions = (options as RadioOption[]) || []

    const handleChange = (selectedValue: string | number) => {
        onChange?.(selectedValue)
    }

    return (
        <div className="w-full">
            {label && (
                <label className="block font-medium text-gray-700 dark:text-gray-200 mb-2 text-sm">
                    {label}
                </label>
            )}
            <Radio.Group
                id={id}
                value={value as string | number}
                vertical={(vertical as boolean) || false}
                onChange={handleChange}
            >
                {radioOptions.map((opt) => (
                    <Radio
                        key={`${id}-${opt.value}`}
                        value={opt.value}
                        disabled={disabled}
                    >
                        {opt.label}
                    </Radio>
                ))}
            </Radio.Group>
            {hasErrors && (
                <div className="mt-1">
                    {errors.map((err, idx) => (
                        <p
                            key={`${id}-error-${idx}`}
                            className="text-red-500 text-xs"
                        >
                            {err}
                        </p>
                    ))}
                </div>
            )}
        </div>
    )
}

SDUIRadio.displayName = 'SDUIRadio'

export default SDUIRadio
